// extracted by mini-css-extract-plugin
export default {"container":"UserManagement_container__qNXHf","formContainer":"UserManagement_formContainer__GSK+J","mainForm":"UserManagement_mainForm__AqlRr"};